import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const SectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background: #F7F8F9;
    border: 1px solid ${colors.gray3};
    border-radius: 12px;
    transition: border-color 0.2s ease;

    ${({noHover}) => !noHover && `
        &:hover {
            border-color: ${colors.darkGray2};
        }
    `}
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-radius: 12px;
    background: #fff;
    ${({clickable}) => clickable && `
        cursor: pointer;
    `}
    
    ${props => props.isOpen &&
        `background-color: #F7F8F9;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 1px solid ${colors.gray3};`
    };
`;

export const SectionHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SectionHeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const SectionIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    
    svg {
        width: 24px;
        height: 24px;
    }
`;

export const SectionTitle = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: ${colors.darkGray1};
`;

export const ArrowIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    transition: transform 0.2s ease;
    
    ${props => props.isOpen && 'transform: rotate(180deg);'}
    
    svg {
        width: 24px;
        height: 24px;
    }
`;

export const SectionContent = styled.div`
    background: #fff;
    border-radius: 0 0 12px 12px;
`; 